// Object of formatted route strings
export class formattedRouteString {
    streetName: string;
    separator: string = "/";
    crossStreet: string;

    constructor(streetName: string = null, crossStreet = null) {
        this.streetName = streetName;
        this.crossStreet = crossStreet;
    }

    toString(): string {
        let temp = this.streetName;
        if (this.crossStreet) {
            temp += `${this.separator}${this.crossStreet}`;
        }
        return temp;
    }
};
